import React, { useEffect, useState } from "react";
import Dropdown from "../../common/dropdown";
import Checkbox from "../../common/checkbox";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import { useGasCalculationFacade } from "../../../facade/calculation/calculation-output/gasCalculation.facade";
import WidgetLoader from "../../common/widgetloader";
import GasHandler from "./gas-handler";
import AddChargePump from "./add-charge-pump";
import GasTable from "./gasTable";
import EquipmentTableAddChargePump from "../../common/equipment-table-charge-pump";
import useTubingFacade from "../../../facade/calculation/calculation-input/tubing.facade";
import useCollapseFacade from "../../../facade/collapse.Facade";
import Accordion from "../../common/accordion";
import { LABELS } from "../../../constants/labels/gasCals.labels";
import useCalculationFacade from "../../../facade/calculation/calculation.facade";
import Error from "../../../assets/icons/Error";
import Select from "../../common/select";

const GasCalculations: React.FC = () => {

    const { loading } = useAppSelector(
        (state) => state?.calculations
    );
    const {
        BasicGasCalculation,
        GasCalculationOutPut,
        anchorODList,
        anchorTubingODList,
        hPRating,
        existedGasSepEquipments,
        chargePumpName,
        chargePump2Name,
        chargePump3Name,
        sepName,
        showGasSeparatorsEquipment,
    } = useAppSelector((state) => state?.gasCalculations);

    const { tab3Input } = useAppSelector((state) => state?.fluid);
    const { gasHandlerPumpName } = useAppSelector((state) => state?.gasHandler);
    const { tab1Input } = useAppSelector(state => state?.tubing);
    const {
        updateGasDesign,
        updateSelectedSeparator,
        updateSepName,
        updateNoOfSeparators,
        updateGasAnchorOD,
        updateGasTubingOD,
        loadEquipmentsGasHandler,
        updateExistedGasSeparatorEquipments,
        loadGasSeparatorEquipments,
        updateShowHideGasSepEquipments,
        loadChargePump1EquipmentList,
        loadChargePump2EquipmentList,
        loadChargePump3EquipmentList,
    } = useGasCalculationFacade();
    const { updateHiddenGasAutoEff, updateHiddenGasNatrAutoEff } = useTubingFacade();
    const { updateSchematicEquipmentData } = useCalculationFacade();
    const [notification, setNotification] = useState(GasCalculationOutPut?.IsTFV_SepWarningVisible);

    useEffect(() => {
        if (GasCalculationOutPut?.IsTFV_SepWarningVisible) {
            setNotification(true);
        } else {
            setNotification(false);
        }
    }, [GasCalculationOutPut?.IsTFV_SepWarningVisible]);

    useEffect(() => {
        if (BasicGasCalculation?.sepSelcted) {
            loadGasSeparatorEquipments();
        };
    }, [BasicGasCalculation?.sepSelcted]);

    useEffect(() => {
        if (BasicGasCalculation?.chargePumpGKX !== "" && gasHandlerPumpName !== "") {
            loadEquipmentsGasHandler();
        }
    }, [BasicGasCalculation?.chargePumpGKX, gasHandlerPumpName]);

    useEffect(() => {
        if (BasicGasCalculation?.useOfChgPmpNew === "1" && BasicGasCalculation?.chargePump !== "" && chargePumpName !== "") {
            loadChargePump1EquipmentList();
        }
    }, [chargePumpName]);

    useEffect(() => {
        if (BasicGasCalculation?.useOfChgPmpNew === "1" && BasicGasCalculation?.chargePump2 !== "" && chargePump2Name !== "") {
            loadChargePump2EquipmentList();
        }
    }, [chargePump2Name]);

    useEffect(() => {
        if (BasicGasCalculation?.useOfChgPmpNew === "1" && BasicGasCalculation?.chargePump3 !== "" && chargePump3Name !== "") {
            loadChargePump3EquipmentList();
        }
    }, [chargePump3Name]);

    const handleSelect = async (
        option: any,
        type:
            | "GasDesign"
            | "NoOfSeparators"
            | "SeparatorType"
            | "AnchorOD"
            | "TubingOD"
    ) => {
        if (type === "GasDesign") {
            updateGasDesign(option?.id);
        } else if (type === "NoOfSeparators") {
            updateNoOfSeparators(option?.name);
            if (option?.name === "0") {
                updateSepName("");
                updateSelectedSeparator("");
                updateShowHideGasSepEquipments(false);
                updateExistedGasSeparatorEquipments([]);
                updateSchematicEquipmentData();
                updateSelectedSeparator("");
                updateSchematicEquipmentData();
            }
            if (showGasSeparatorsEquipment && (existedGasSepEquipments?.length > 0 || BasicGasCalculation?.EquipmentListForGasSeparator?.length > 0) && option?.name !== "0") updateShowHideGasSepEquipments(showGasSeparatorsEquipment);
            if (showGasSeparatorsEquipment && existedGasSepEquipments?.length && option?.name) {
                const currentLength = existedGasSepEquipments?.length;
                const desiredLength = Number(option.name);

                if (currentLength > desiredLength) {
                    updateExistedGasSeparatorEquipments(existedGasSepEquipments.slice(0, desiredLength));
                    updateSchematicEquipmentData();
                }
            }
        } else if (type === "SeparatorType") {
            updateSelectedSeparator(option?.id);
            updateSepName(option?.label);
            updateExistedGasSeparatorEquipments([]);
            if (!showGasSeparatorsEquipment && BasicGasCalculation?.EquipmentListForGasSeparator?.length > 0 && !existedGasSepEquipments) {
                updateShowHideGasSepEquipments(true);
            }
        } else if (type === "AnchorOD") {
            updateGasAnchorOD(option?.id);
            updateGasTubingOD("");
            if (option?.id === "") {
                updateGasAnchorOD("-1");
                updateGasTubingOD("");
            }
        } else if (type === "TubingOD") {
            updateGasTubingOD(option?.id);
        } else {
            return;
        }
    };

    const handleCheckbox = (
        event: React.ChangeEvent<HTMLInputElement>,
        type: "Natural Separation" | "Auto Eff"
    ) => {
        const data = event?.target?.checked;
        if (type === "Natural Separation") {
            updateHiddenGasNatrAutoEff(Number(data)?.toString());
        } else if (type === "Auto Eff") {
            updateHiddenGasAutoEff(Number(data)?.toString());
        }
    };

    const handleOnClearEquipment = (id: string, index: number) => {
        const updatedEquipments = [...existedGasSepEquipments];
        if (index === 0) {
            updateExistedGasSeparatorEquipments([{}]);
        } else {
            updatedEquipments.splice(index);
            if (
                updatedEquipments.length === 0 ||
                updatedEquipments[updatedEquipments.length - 1]?.id !== undefined
            ) {
                updatedEquipments.push({});
            }
            updateExistedGasSeparatorEquipments(updatedEquipments);
        }
        updateSchematicEquipmentData();
    };

    const handleSelectEquipments = (option: any, index: number) => {
        let updatedArray = [...existedGasSepEquipments];
        if (updatedArray[index]) {
            const existingItem = updatedArray[index];
            const isDifferent = JSON.stringify(existingItem) !== JSON.stringify(option);
            if (isDifferent) {
                updatedArray[index] = option;
            }
        } else {
            const emptyIndex = updatedArray.findIndex(
                (item) => Object.keys(item).length === 0
            );
            if (emptyIndex !== -1) {
                updatedArray[emptyIndex] = option;
            } else {
                updatedArray[index] = option;
            }
            if (updatedArray.length < Number(BasicGasCalculation?.noOfGasSeps)) {
                updatedArray.push({});
            }
        }
        updateExistedGasSeparatorEquipments(updatedArray);
        updateSchematicEquipmentData();
    };

    useEffect(() => {
        if (
            BasicGasCalculation?.noOfGasSeps &&
            Number(BasicGasCalculation?.noOfGasSeps) >
            existedGasSepEquipments.length &&
            !existedGasSepEquipments.some(
                (item: any) => Object.keys(item).length === 0
            ) && showGasSeparatorsEquipment
        ) {
            updateExistedGasSeparatorEquipments([...existedGasSepEquipments, {}]);
            updateShowHideGasSepEquipments(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [BasicGasCalculation?.noOfGasSeps, existedGasSepEquipments, showGasSeparatorsEquipment]);

    const { summaryCollapse, gasSeparatorCollapse } = useAppSelector(
        (state) => state?.collapse
    );

    const { updateSummaryCollapse, updateGasSeparatorCollapse } =
        useCollapseFacade();

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "summary") updateSummaryCollapse(key);
        else if (name === "gasSeparator") updateGasSeparatorCollapse(key);
    };

    return (
        <>
            {loading ? (
                <div className="absolute inset-0 flex justify-center items-center bg-darkcolor-700 bg-opacity-30">
                    <WidgetLoader isLoading={loading} />
                </div>
            ) : (
                <div className="flex flex-col justify-center item-center w-full h-full gap-[16px]">
                    {notification && GasCalculationOutPut?.IsTFV_SepWarningVisible && (
                        <div className="flex items-center p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-warning-600 border-warning-600">
                            <Error />
                            <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                                {LABELS?.tfvWarningMessage}
                            </p>
                        </div>
                    )}
                    <Accordion
                        title={LABELS?.summary}
                        isOpen={summaryCollapse}
                        link={'/help?tab=Gas-Calculations#gas-formulas'}
                        tooltipText={LABELS?.formula}
                        onToggle={() => handleCollapseChange(!summaryCollapse, "summary")}
                        content={
                            <div className="flex justify-center items-center p-4 gap-4 w-full">
                                <div className="flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2">
                                    <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                                        <label className="text-neutral-25 text-[14px] font-normal">
                                            {LABELS?.design}
                                        </label>
                                        <label className="text-neutral-25">
                                            {BasicGasCalculation?.gasDesign === "0" || BasicGasCalculation?.gasDesign === null || BasicGasCalculation?.gasDesign === undefined
                                                ? `${LABELS?.standardSeparation}`
                                                : `${LABELS?.gasAnchor}`}
                                        </label>
                                    </div>
                                    <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                                        <label className="text-neutral-25">{LABELS?.separatorwithcolon}</label>
                                        <label className="text-neutral-25">{sepName}</label>
                                    </div>
                                    <div className="flex justify-between items-center py-[9px] px-[24px] w-full">
                                        <label className="text-neutral-25">{LABELS?.gasHandlerwithcolon}</label>
                                        <label className="text-neutral-25">
                                            {BasicGasCalculation?.useOfChgPmp === "1" && gasHandlerPumpName}
                                        </label>
                                    </div>
                                </div>
                                <div className="flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2">
                                    <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                                        <label className="text-neutral-25">{LABELS?.chargePump1withcolon}</label>
                                        <label className="text-neutral-25">{`${chargePumpName ? chargePumpName : ""} ${BasicGasCalculation?.chargePumpDesrdStge
                                            ? `| ${BasicGasCalculation?.chargePumpDesrdStge} ${LABELS?.stg}`
                                            : ""
                                            }`}</label>
                                    </div>
                                    <div className="flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400">
                                        <label className="text-neutral-25">{LABELS?.chargePump2withcolon}</label>
                                        <label className="text-neutral-25">{`${chargePump2Name ? chargePump2Name : ""} ${BasicGasCalculation?.chargePumpDesrdStge2
                                            ? `| ${BasicGasCalculation?.chargePumpDesrdStge2} ${LABELS?.stg}`
                                            : ""
                                            }`}</label>
                                    </div>
                                    <div className="flex justify-between items-center py-[9px] px-[24px] w-full">
                                        <label className="text-neutral-25">{LABELS?.chargePump3withcolon}</label>
                                        <label className="text-neutral-25">{`${chargePump3Name ? chargePump3Name : ""} ${BasicGasCalculation?.chargePumpDesrdStge3
                                            ? `| ${BasicGasCalculation?.chargePumpDesrdStge3} ${LABELS?.stg}`
                                            : ""
                                            }`}</label>
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <Accordion
                        title={LABELS?.gasSeparator}
                        isOpen={gasSeparatorCollapse}
                        link={'/help?tab=Gas-Calculations#gas-formulas'}
                        tooltipText={LABELS?.formula}
                        onToggle={() =>
                            handleCollapseChange(!gasSeparatorCollapse, "gasSeparator")
                        }
                        content={
                            <div className="flex flex-wrap w-full gap-4 p-4">
                                <div className={`flex flex-col w-[32%] gap-2`}>
                                    <Dropdown
                                        label={LABELS?.gasDesign}
                                        options={[
                                            { id: "0", name: "Standard Separation" },
                                            { id: "1", name: "Gas Anchor" },
                                        ]}
                                        onSelect={(option) => handleSelect(option, "GasDesign")}
                                        dropdownBgColor="bg-darkcolor-800"
                                        bgColor="bg-transparent"
                                        selected={BasicGasCalculation?.gasDesign ?? "0"}
                                        border={true}
                                    />
                                    <Checkbox
                                        label={LABELS?.naturalSeparation}
                                        checked={tab1Input?.hiddenGasNatrEffAuto === "1"}
                                        name="naturalSeparation"
                                        onChange={(e) => handleCheckbox(e, "Natural Separation")}
                                    />
                                </div>
                                {BasicGasCalculation?.gasDesign === "1" && (
                                    <>
                                        <div className="flex w-[32%]">
                                            <Dropdown
                                                label="Anchor OD"
                                                options={anchorODList}
                                                onSelect={(option) => handleSelect(option, "AnchorOD")}
                                                dropdownBgColor="bg-darkcolor-800"
                                                bgColor="bg-transparent"
                                                selected={BasicGasCalculation?.anchorOD}
                                                showSelectOption
                                                border={true}
                                            />
                                        </div>
                                        <div className="flex flex-col gap-2 w-[32%]">
                                            <Dropdown
                                                label={LABELS?.tubingOD}
                                                options={anchorTubingODList}
                                                onSelect={(option) => handleSelect(option, "TubingOD")}
                                                dropdownBgColor="bg-darkcolor-800"
                                                bgColor="bg-transparent"
                                                selected={BasicGasCalculation?.tubingOD}
                                                border={true}
                                            />
                                            <div className="flex justify-between items-center">
                                                <label className="text-neutral-25">{LABELS?.anchorID}</label>
                                                <label className="text-neutral-25">
                                                    {BasicGasCalculation?.anchorID} {LABELS?.in}
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div
                                    className={`flex flex-col ${BasicGasCalculation?.gasDesign === "1"
                                        ? "w-[49%]"
                                        : "w-[32%]"
                                        } gap-2`}
                                >
                                    <Dropdown
                                        label={LABELS?.noOfSeparator}
                                        options={[
                                            { id: "0", name: "0" },
                                            { id: "1", name: "1" },
                                            { id: "2", name: "2" },
                                            { id: "3", name: "3" },
                                            { id: "4", name: "4" },
                                        ]}
                                        onSelect={(option) =>
                                            handleSelect(option, "NoOfSeparators")
                                        }
                                        dropdownBgColor="bg-darkcolor-800"
                                        bgColor="bg-transparent"
                                        selected={BasicGasCalculation?.noOfGasSeps ?? "0"}
                                        border={true}
                                    />
                                    {BasicGasCalculation?.noOfGasSeps !== "0" && (
                                        <label className="text-neutral-25">
                                            {LABELS?.power} {tab3Input?.operatngFreq} {LABELS?.hz} {hPRating ?? ""} {LABELS?.hp}
                                        </label>
                                    )}
                                </div>
                                <div
                                    className={`flex flex-col ${BasicGasCalculation?.gasDesign === "1"
                                        ? "w-[49%]"
                                        : "w-[32%]"
                                        } gap-2`}
                                >
                                    {["1", "2", "3", "4"].includes(BasicGasCalculation?.noOfGasSeps ?? "") && (
                                        <>
                                            <Select
                                                label={LABELS?.separator}
                                                options={BasicGasCalculation?.separatorList ?? []}
                                                onChange={(option) => handleSelect(option, "SeparatorType")}
                                                padding="px-[14px] py-[7px]"
                                                fontSize="16px"
                                                className="sm:px-0 px-[10px]"
                                                selectedValue={BasicGasCalculation?.sepSelcted ?? ""}
                                            />
                                            <Checkbox
                                                label={LABELS?.autoEfficiency}
                                                checked={tab1Input?.hiddenGasAutoEff === "1"}
                                                name="Auto Eff"
                                                onChange={(e) => handleCheckbox(e, "Auto Eff")}
                                            />
                                        </>
                                    )}
                                </div>
                                {showGasSeparatorsEquipment ? (
                                    <div className="flex w-full overflow-x-auto">
                                        <EquipmentTableAddChargePump
                                            options={BasicGasCalculation?.EquipmentListForGasSeparator}
                                            onChange={handleSelectEquipments}
                                            equipments={existedGasSepEquipments?.length > 0 ? existedGasSepEquipments : [{}]}
                                            onClear={(value: string, index: number) => { handleOnClearEquipment(value, index) }}
                                            rowLength={Number(BasicGasCalculation?.noOfGasSeps)}
                                            equipmentGridParentContainer="SRGasSeparators"
                                            parentId={BasicGasCalculation?.sepSelcted}
                                            styles={{ width: "200px", wordWrap: "break-word" }}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        }
                    />
                    <GasHandler />
                    <AddChargePump />
                    {GasCalculationOutPut && Object.keys(GasCalculationOutPut)?.length > 0 && <GasTable />}
                </div>
            )}
        </>
    );
};

export default GasCalculations;
